import { FC } from 'react';

import { Box, BoxProps } from '@mantine/core';

import { CompanyProfile as CompanyProfileType, PermissionCompany } from 'models';

import { PublishProfileNotice } from 'components/company-profile/components/PublishProfileNotice';
import { UpgradeSuccesNotice } from 'components/company-profile/components/UpgradeSuccesNotice';
import { useProfilePermission } from 'components/company-profile/hooks/use-profile-permission';
import { CompanySubscriptionNotice } from 'components/subscriptions/subscription-notice/CompanySubscriptionNotice';

import cx from './Notices.module.scss';

const Notices: FC<{ company: CompanyProfileType } & BoxProps> = ({ company, ...rest }) => {
    const canEdit = useProfilePermission(PermissionCompany.EDIT, company);

    if (!canEdit) {
        return null;
    }

    return (
        <Box className={cx.root} {...rest}>
            <PublishProfileNotice company={company} />
            <CompanySubscriptionNotice company={company} />
            <UpgradeSuccesNotice />
        </Box>
    );
};

export { Notices };
